import { MetricsColorEnum } from '@ecdlink/core';
import { AlertSeverityType } from '@ecdlink/ui';

export const limitStringLength = (string = '', limit = 0) => {
  if (string.trim().length > 50) {
    return string.substring(0, limit) + '...';
  } else {
    return string.substring(0, limit);
  }
};

// TODO: put it in Ui package
export const getAlertSeverity = (color: string): AlertSeverityType => {
  switch (color) {
    case MetricsColorEnum.Error:
      return 'error';
    case MetricsColorEnum.Warning:
      return 'warning';
    case MetricsColorEnum.Success:
      return 'success';
    default:
      return 'none';
  }
};

export const normalizeStringWithoutConsiderNumbers = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\b\d{4}[\/\-.]\d{1,2}[\/\-.]\d{1,2}\b/g, '')
    .replace(/\b\d{1,2}[\/\-.]\d{1,2}[\/\-.]\d{2,4}\b/g, '')
    .replace(/\b\d{1,2}:\d{2}(?:\s?[ap]m)?\b/gi, '')
    .replace(/^\s*\d+\s*/, '')
    .replace(/\bvisits?\b/gi, '')
    .replace(/\(not registered\)/gi, '')
    .replace(/\bnot registered\b/gi, '')
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
};
